




































































import EmployeeAttendViewPairLine from "@/components/EmployeeAttendViewPairLine.vue";
import store from "@/store";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    components: {
        EmployeeAttendViewPairLine,
    },
})
export default class EmployeeAttendViewShift extends Vue {
    @Prop() shift: any;
    @Prop() shiftIndex: number;

    shiftExpanded = false;

    constructor() {
        super();
    }

    toggleShiftExpand() {
        this.shiftExpanded = !this.shiftExpanded;
    }

    get numberOfPairs() {
        return this.shift.lines.length || 0;
    }

    get appEnv() {
        return store.getters.appEnv;
    }
}
